'use client'

import { FC } from 'react'

import styles from './styles.module.css'
import { IOptionProps } from './types'

const GenericOption: FC<IOptionProps> = ({
  onClick,
  text,
  className,
  icon,
}) => {
  return (
    <div className={`${styles.option} ${className}`} onClick={onClick}>
      {!!icon && icon}
      <p className={styles.optionText}>{text ?? 'Ativar'}</p>
    </div>
  )
}

export default GenericOption
